import styled from '@emotion/styled'
import { HeaderLink, SimpleLink } from './link'

import { H1, H2, H4, Header16, Header20, Header24, Paragraph16 } from '../../styles/typography'
import { scrollToSection } from '../../utils'
import nameLogo from '../../assets/logos/company-logo1.7.png'
import mailIcon from '../../assets/icons/mail-icon.png'
import phoneIcon from '../../assets/icons/phone-icon.png'
import locationIcon from '../../assets/icons/location-icon.png'
import whiteLine from '../../assets/images/white-line.png'
import instagramLogo from '../../assets/logos/logo-instagram.png'
import facebookLogo from '../../assets/logos/logo-facebook.png'
import linkedInLogo from '../../assets/logos/logo-linkedIn.png'
import yelpLogo from '../../assets/logos/yelp-logo.png'
import { Link } from 'react-router-dom'

const NavWrapper = styled.nav`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background-color: ${(props) => props.theme.primaryColor.blue[1]};
    color: ${(props) => props.theme.primaryColor.white[3]};
    top: 0;
    z-index: 10;
    transition: all 0.3s;

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        padding: unset;
        flex-direction: column;
        gap: 32px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding: 64px 32px;
    }
`

const NavContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 40px 16px;
    align-items: flex-start;
    width: 100%;
    max-width: ${(props) => props.theme.containerWidth};

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        padding: 64px 0px;
        flex-direction: column;
        align-items: center;
        gap: 32px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        margin: 64px 0px;
    }
`

const LinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        align-items: center;
    }
`
const InfoWrapper = styled(LinkWrapper)`
    h1 {
        font-family: Inter-Light;
        font-size: 16px;
        font-weight: 200;
        margin: unset;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        align-items: flex-start;
        h1 {
            font-size: 16px;
        }
    }
`

const SocialWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: center;
`

const FinalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: flex-start;
    justify-content: space-between;
    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        gap: 8px;
        align-items: center;
    }
`

const PolicyWrapper = styled.div`
    display: flex;
    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        justify-content: center;
    }
`

const AddressWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        text-align: center;
        gap: 16px;
    }
`

const FooterLink = styled.a`
    position: relative;
    display: inline-block;
    color: ${(props) => props.theme.primaryColor.white[1]};
    text-decoration: none;
    text-transform: unset;
    cursor: pointer;
    text-transform: unset;
    text-decoration: none;
    font-family: Inter-Light;
    font-size: 16px;
    font-weight: 200;
    margin: 0;

    &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0%;
        height: 2px;
        background-color: ${(props) => props.theme.primaryColor.white[1]};
        transition: width 0.3s ease;
    }

    &:hover::after {
        width: 100%;
    }

    &:active {
        color: ${(props) => props.theme.primaryColor.orange[1]};
    }

    &:active::after {
        background-color: ${(props) => props.theme.primaryColor.orange[1]};
    }
`

const FooterIconLink = styled(FooterLink)`
    &::after {
        content: '';
        position: absolute;
        bottom: 2px;
        left: 0;
        width: 0%;
        height: 2px;
        background-color: ${(props) => props.theme.primaryColor.white[1]};
        transition: width 0.3s ease;
    }
`

export function Footer() {
    const address = '3036 7th Ave, Port Alberni, British Columbia'
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`

    const phoneNumberRaw = '+12507301007'

    return (
        <NavWrapper>
            <NavContainer>
                <AddressWrapper>
                    <HeaderLink to='/' onClick={() => scrollToSection('hero')}>
                        <img src={nameLogo} style={{ width: '184px' }} />
                    </HeaderLink>
                </AddressWrapper>

                <LinkWrapper>
                    <Header20>Pages</Header20>
                    <HeaderLink to='/' onClick={() => scrollToSection('hero')}>
                        <FooterLink>
                            <Header16>Home</Header16>
                        </FooterLink>
                    </HeaderLink>

                    <HeaderLink to='/about'>
                        <FooterLink>
                            <Header16>About</Header16>
                        </FooterLink>
                    </HeaderLink>

                    <HeaderLink to='/services'>
                        <FooterLink>
                            <Header16>Services</Header16>
                        </FooterLink>
                    </HeaderLink>

                    <HeaderLink to='/contact'>
                        <FooterLink>
                            <Header16>Contact</Header16>
                        </FooterLink>
                    </HeaderLink>
                </LinkWrapper>

                <InfoWrapper>
                    <Header20>Info</Header20>

                    <img src={whiteLine} style={{ height: '1px', width: '100%' }} />

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <img src={phoneIcon} style={{ width: '16px', height: '16px' }} />
                        <FooterLink href={`tel:${phoneNumberRaw}`}>+1 (250) 730 - 1007</FooterLink>
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <img src={mailIcon} style={{ width: '16px', height: '16px' }} />
                        <FooterLink href='mailto:jbartley@jbfineline.ca' target='_blank'>
                            jbartley@jbfineline.ca
                        </FooterLink>
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <img src={locationIcon} style={{ width: '16px', height: '18px' }} />
                        <FooterLink href={mapsUrl} target='_blank' rel='noopener noreferrer' style={{ flex: 1 }}>
                            3036 7th Ave, Port Alberni, British Columbia
                        </FooterLink>
                    </div>
                </InfoWrapper>

                <LinkWrapper style={{ height: '100%' }}>
                    <Header20>Socials</Header20>
                    <FinalWrapper>
                        <SocialWrapper>
                            <SimpleLink
                                to='https://www.instagram.com/jbfinelineconstruction/'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <FooterIconLink>
                                    <img src={instagramLogo} style={{ width: '24px', height: '24px' }} />
                                </FooterIconLink>
                            </SimpleLink>
                            <SimpleLink
                                to='https://www.facebook.com/profile.php/?id=61551259773631'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <FooterIconLink>
                                    <img src={facebookLogo} style={{ width: '24px', height: '24px' }} />
                                </FooterIconLink>
                            </SimpleLink>
                            <SimpleLink
                                to='https://www.yelp.ca/biz/j-and-j-fine-line-construction-port-alberni'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <FooterIconLink>
                                    <img src={yelpLogo} style={{ width: '24px', height: '24px' }} />
                                </FooterIconLink>
                            </SimpleLink>
                        </SocialWrapper>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <PolicyWrapper>
                                <Link to='/policy' style={{ textDecoration: 'none', marginTop: '-1px' }}>
                                    <FooterLink>
                                        <Header16>Privacy Policy</Header16>
                                    </FooterLink>
                                </Link>
                            </PolicyWrapper>

                            <div style={{ display: 'flex', gap: '4px' }}>
                                <Paragraph16>Website made by</Paragraph16>
                                <Link
                                    to='https://edraprasetio.com/'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{ textDecoration: 'none', marginTop: '-1px' }}
                                >
                                    <FooterLink>
                                        <Header16>Edra Prasetio</Header16>
                                    </FooterLink>
                                </Link>
                            </div>
                        </div>
                    </FinalWrapper>
                </LinkWrapper>
            </NavContainer>
        </NavWrapper>
    )
}
